import { IncompleteActivityState } from './incomplete-activity-state';
import { ActivityState } from './activity-state';

export interface ActivityFolder {
  activityId: string;
  timesCompleted: number;
  maxStars: number;
  fastestTimeInSecs: number;
  incompleteActivityState?: IncompleteActivityState; //if undefined/null, we don't have an activity in progress
  completions: ActivityState[]; // capped at 5, inclusive of assignments
  assignmentCompletions: ActivityState[]; //no cap, exclusive to assignments
}
